<!-- eslint-disable -->
<template>
	<div>
		<div class="d-flex mx-auto mt-4" style="max-width: 360px;height: 160px;">
			<img class="image-fit" src="@/assets/images/img_locker_success.png" alt="locker_success" style="width: 100%;"/>
		</div>

		<div class="m-auto text-center" style="width: 100%;">
			<div class="text-center px-4">
				<div class="text-gotham-bold text-18 pt-4 pb-2">{{ title }}</div>
				<div class="text-14" style="color:#929293">{{ description }}</div>
			</div>
		</div>

		<div style="bottom:0;position: absolute;width: 100%;" class="p-4">
			<button
				data-cta="orderstatus_action_stop_success_lihat_status"
				@click="backToOrder()"
				class="button rounded-lg py-3 text-gotham-bold"
				style="width: 100%;background-color:#5F51A1;color:white;border:1px solid #5F51A1;"
			>
				<span class="text-gotham-bold text-white text-16" style="cursor: pointer">
					{{ language == "en" ? "See Order" : "Lihat Status" }}
				</span>
			</button>
		</div>
	</div>
</template>
<script>
/* eslint-disable */
import LocalStorage from '@/services/localstorage';

export default {
	data() {
		return {
			title: "",
			description: ""
		};
	},
	beforeMount() {
		this.title = this.language == "en" ? "Rent has Ended" : "Sewa Telah Berakhir";
		this.description =
			this.language == "en"
				? "Thank you for using PaxelBox. Have a nice day!"
				: "Terima kasih telah menggunakan PaxelBox. Semoga harimu menyenangkan!";
	},
	methods: {
		backToOrder(){
			let url  = window.location.origin+"/order-status?orderid="+LocalStorage.getOrderId()+"&token="+LocalStorage.getUserToken()
			window.location.replace(url)
		}
	}
};
</script>
